import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  height: 100%;
  margin-top: 26px;

  @media (max-width: 1000px) {
    align-items: center;
  }
  @media (max-width: 600px) {
    margin-top: 30px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Input = styled.input`
  width: 295px;
  height: 70px;
  padding: 10px;
  margin-right: 24px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0.5px;
  color: #000000;
  font-family: NunitoSans-SemiBold;
  background: #ffffff;
  outline-color: #d67723;
  border: 1px solid #e2e5ed;
  box-sizing: border-box;
  box-shadow: inset 0px 1px 2px rgba(102, 113, 123, 0.21);
  border-radius: 2px;
  border: 1px solid #e2e5ed;

  @media (max-width: 360px) {
    width: 250px;
  }
`;

export const Break = styled.div`
  flex-basis: 100%;
  height: 0;
`;

export const Button = styled.button`
  height: 70px;
  font-family: NunitoSans-SemiBold;
  font-weight: 600;
  width: 170px;
  outline: none;
  border-radius: 8px;
  background: #d67723;
  color: white;
  font-size: 16px;
  line-height: 30px;
  border: 0;
  cursor: pointer;
  letter-spacing: 0.5;

  @media (max-width: 600px) {
    margin-top: 24px;
    height: 47px;
    width: 140px;
    font-size: 14px;
    line-height: 20px;
    padding: 0px;
    text-align: center;
  }
`;

export const Text = styled.p`
  font-size: 19.2px;
  color: white;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 16px;
    line-height: 22px;
  }
`;
